/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the PoliticalAds HTTP resource (factory product). */
export class PoliticalAdsResource {
}

export function createPoliticalAdsResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const PoliticalAds: any = createAdnHttpResource(send, 'politicalads', () => localUserProfile);

  PoliticalAds.getHtmlTemplate = function(): Promise<any> {
    return send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['politicalads', 'template', 'transparency-notice'])
    });
  };
  PoliticalAds.getRenderDsaTemplate = function(): Promise<any> {
    return send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['politicalads', 'template', 'transparency-overlay'])
    });
  };
  PoliticalAds.renderHtml = function(params: any): Promise<any> {
    return send({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri(['politicalads', 'html', 'render']),
      headers: {Accept: 'text/html'},
      responseType: 'text',
      body: _.pickBy({
        n: params.n,
        li: params.li,
        p: params.p,
        template: params.template
      }, (value: any) => value !== undefined && value !== null && value !== '')
    });
  };

  return PoliticalAds;
}

export const politicalAdsResourceProvider = {
  provide: PoliticalAdsResource,
  useFactory: createPoliticalAdsResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

